import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@ui/Button';
import Icon from '@ui/Icon';
import Tooltip from '@ui/Tooltip';

import classes from './style.module.scss';

/**
 * Returns the state and toggle for showing/hiding a password.
 */
export default function useShowPasswordToggle(initialState: boolean = true) {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(initialState);
  const ShowPasswordToggle = (
    <Tooltip content={showPassword ? t('auth.passwordHideLabel') : t('auth.passwordShowLabel')}>
      <Button
        aria-label={showPassword ? t('auth.passwordHideLabel') : t('auth.passwordShowLabel')}
        className={`rm-APIAuth-lock ${classes['APIAuth-lock']}`}
        kind="minimum"
        onClick={() => setShowPassword(!showPassword)}
        size="xs"
        text
      >
        <Icon aria-hidden name={showPassword ? 'lock' : 'unlock'} />
      </Button>
    </Tooltip>
  );

  return { ShowPasswordToggle, showPassword };
}
